(function(window, angular) {
  "use strict";

  var ngSocketIO = angular.module('ngSocketIO', []);

  ngSocketIO.factory('socketio', ['$rootScope', function ($rootScope) {
    var url     = config && config.io && config.io.url ? config.io.url : null;
    var channel = config && config.io && config.io.channel ? config.io.channel : null;
    if( !url || !channel ) {
      console.log("check the config.io.url in layouts.master");
      return null;
    }
    var socket = io.connect(url);
    return {
      on: function (callback) {
        socket.on(channel, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            callback.apply(socket, args);
          });
        });
      },
      emit: function (data, callback) {
        socket.emit(channel, data, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            if (callback) {
              callback.apply(socket, args);
            }
          });
        })
      }
    };
  }]);

})(window, window.angular);
